// src/utils/roomDeviceMap.js
export const roomHierarchyMap = {
  "Verge Hospital": {
    "2M Carts": {
      "VH 2M 300": "66189",
      "VH 2M 301": "58039",
      "VH 2M 302": "50864",
      "VH 2M 303": "39331",
      "VH 2M 304": "66094",
      "VH 2M 332": "63874",
    },
    "ICU Wall": {
      "RH ICU 201": "66169",
      "RH ICU 202": "89048",
      "RH ICU 203": "66184",
      "RH ICU 204": "66179",
      "RH ICU 205": "67189",
      "RH ICU 206": "63889",

    },
  },
};
